const getTableValues = (data, keyAs) => {
  let records = [];
  if (data && Array.isArray(data)) {
    records = data
      .filter((d) => d)
      .filter((d) => !d.removed) // if it hasn't been soft deleted
      .filter((d) => JSON.stringify(d) !== "{}")
      .filter((d) => d.form)
      .map((d) => {
        return getFormOverrides(d, keyAs);
      });
  }
  return records;
};

export const getFormOverrides = (appForm, keyAs = "id") => {
  let form = appForm.form;
  if (!form) {
    form = appForm["*form"];
  }
  if (!form) return;
  return form
    .filter((item) => item && item.id)
    .reduce((result, item) => {
      let value = {};
      let tableValue = {};
      switch (item.type) {
        case "table":
          value = getTableValues(item.value, keyAs);
          break;

        default:
          /**
           * @param {boolean} accessible field visibility
           */
          typeof item.accessible === "boolean" && item.value && (value.value = item.value);
          typeof item.accessible === "boolean" && (value.accessible = item.accessible);

          break;
      }

      if (Object.keys(value).length === 0) return result;

      let _id = item.altId ? item.altId : item.id;
      if (keyAs === "label" && item.name) {
        result[item.name] = value;
      } else if (keyAs === "labelAndId") {
        result[`${item.name}_____${_id}`] = value;
      } else {
        result[_id] = value;
      }

      return result;
    }, {});
};



// WEBPACK FOOTER //
// ./src/components/Reports/utils/getFormOverrides.js